<template>
	<v-app>
		<toast-container></toast-container>
		<app-header v-if="loggedIn"></app-header>
		<app-sidebar v-if="loggedIn"></app-sidebar>
		<v-content>
			<router-view></router-view>
		</v-content>
	</v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import rmdyAuth, { AUTH_ACTIONS } from '@rmdy/rmdy-authentication-frontend';
import { AUTH_GETTERS } from '@rmdy/rmdy-authentication-frontend/src/authentication.constants';
import axiosInstance from './services/backendApi';
import AppHeader from './components/main-layout/app-header';
import AppSidebar from './components/main-layout/app-sidebar';
import ToastContainer from './components/toast/toast-container';

export default {
	name: 'App',
	components: {
		AppSidebar,
		AppHeader,
		ToastContainer
	},
	computed: {
		...mapGetters({
			loggedIn: `${rmdyAuth.moduleName}/${AUTH_GETTERS.LOGGED_IN}`,
		}),
	},
	created() {
		axiosInstance.interceptors.response.use(
				response => response,
				error => new Promise(async (resolve, reject) => {
					if (error && error.response) {
						// Check if unauthenticated
						if (error.response.status === 401) {
							// Check if user was logged in
							if (await this.$store.getters[`${rmdyAuth.moduleName}/${AUTH_GETTERS.LOGGED_IN}`]) {
								// Try refreshing the expired jwt token
								this.tryRefresh()
										.then((newJwtToken) => {
											const requestConfig = error.config;
											requestConfig.headers.Authorization = newJwtToken;
											axios.request(requestConfig)
													.then(
															result => resolve(result),
															retryError => reject(retryError),
													);
										})
										.catch(() => {
											this.logout();
											this.$router.push({ name: 'login' });
											resolve();
										});
							} else {
								// Log out user
								this.logout();
								this.$router.push({ name: 'login' });
								resolve();
							}
						} else if (error.response.status === 403) {
							// Redirect to root / unauthorized page
							this.logout();
							this.$router.push('/login');
							resolve();
						} else {
							reject(error);
						}
					} else {
						reject(error);
					}
				}),
		);
	},
	methods: {
		...mapActions({
			logout: `${rmdyAuth.moduleName}/${AUTH_ACTIONS.LOGOUT}`,
			tryRefresh: `${rmdyAuth.moduleName}/${AUTH_ACTIONS.TRY_REFRESH}`,
		}),
	}
};
</script>
